import React, {useEffect, useState} from 'react';
import Loader from "react-loader-spinner";
import * as typingCenterUserActions from '../../Redux/Actions/typingCenterUser';
import {toastMessage} from '../../utils/toast';
import { useDispatch } from 'react-redux';
import { useTranslation } from "react-i18next";
import { validationError, clearSession } from '../../utils/initiate';

const AddUser = ({ history }) => {

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [mobileNumber, setMobileNumber] = useState('');
    const [extensionNumber, setExtensionNumber] = useState('');
    const [userLimit, setUserLimit] = useState('');
    const [emiratesId, setEmiratesId] = useState('');
    const [buttonLoading, setButtonLoading] = useState(false);

    const [loading, setLoading] = useState(false);
    const [departmentsList, setDepartmentsList] = useState([]);
    const [masterProcessList, setMasterProcessList] = useState([]);
    const [departmentID, setDepartmentID] = useState('');
    const [selectedDepartment, setSelectedDepartment] = useState([]);
    const [selectedMasterProcess, setSelectedMasterProcess] = useState([]);

    const dispatch = useDispatch();
    const { t } = useTranslation();

    useEffect(() => {
        setLoading(true);
        typingCenterUserActions.getAllServices().then(res => {
            if(res && res.data){
                setLoading(false);
                setDepartmentsList(res.data.departments);
            }else{
                toastMessage('error', 'Unable to load the process');
            }
        }).catch(err => {
            toastMessage('error', `Unable to load the process`);
        });

        setName(''); setEmail(''); setMobileNumber(''); setExtensionNumber('');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleList = (key, ID) => {
        let list = [];
        if (key === 'department'){
            list = departmentsList.filter(({id}) => id === ID)[0].masterProcess;
            setMasterProcessList(list);
        }
        // else{
        //     list = masterProcessList.filter(({id}) => id === ID)[0].process;
        //     setProcessList(list);
        // }
    };

    const handleSelectedDepartment = (event) => {
        let list = departmentsList.filter(({id}) => id === parseInt(event.target.value, 10))[0].masterProcess;
        if (event.target.checked){
            setSelectedDepartment([...selectedDepartment, parseInt(event.target.value, 10)]);
            list = list.map(({id}) => id);
            let newList = [...list, ...selectedMasterProcess]
            let rmDuplicates = [...new Set(newList)];
            setSelectedMasterProcess(rmDuplicates);
        }else{
            const newList = selectedDepartment.map(item => (item === parseInt(event.target.value, 10)) ? false : item).filter(Boolean);
            setSelectedDepartment(newList)
            list.map(({id}) => {
                let Index = selectedMasterProcess.indexOf(id);
                return (Index === -1) ? '' : selectedMasterProcess.splice(Index, 1);
            });
            setSelectedMasterProcess(selectedMasterProcess);
        }
    };
  
    const handleSelectedMasterProcess = (event, deptID) => {
        let mpList = departmentsList.filter(({id}) => id === parseInt(deptID, 10))[0].masterProcess;
        if (event.target.checked){
            let updatedMP = [...selectedMasterProcess, parseInt(event.target.value, 10)];
            let updatedDP = [];
            if (mpList.length === 1) {
                updatedDP = [...selectedDepartment, parseInt(deptID, 10)];
            } else {
                let multipleMP = [];
                mpList.forEach(({id}) =>
                    updatedMP.includes(id) ? multipleMP.push(id) : ''
                );
                updatedDP = (mpList.length === multipleMP.length) ? [...selectedDepartment, parseInt(deptID, 10)] : selectedDepartment;
            }
            setSelectedDepartment(updatedDP);
            setSelectedMasterProcess(updatedMP);
        }else{
            const deptList = selectedDepartment.map(item => (item === deptID) ? false : item).filter(Boolean);
            setSelectedDepartment(deptList)
            const newList = selectedMasterProcess.map(item => (item === parseInt(event.target.value, 10)) ? false : item).filter(Boolean);
            setSelectedMasterProcess(newList);
        }
    };
      
    const isDeptChecked = id => selectedDepartment.find(item => item === parseInt(id, 10));
    const isMPChecked = id => {
        let response = selectedMasterProcess.find(item => item === parseInt(id, 10));
        return (response === undefined) ? false : response;
    };

    const handleAddUser = () => {
        let payload = { name, email, mobileNumber, extensionNumber, userLimit, emiratesId, skillIds: selectedMasterProcess };
        setButtonLoading(true);
        if((name !== '') && (email !== '') && (userLimit !== '') && (emiratesId !== '') && (selectedMasterProcess.length !== 0)){
            typingCenterUserActions.create(payload).then(res => {
                if(res && res.data){
                    toastMessage('success', `User added successfully`);
                    history.push('/users');
                    setName(''); setEmail(''); setMobileNumber(''); setExtensionNumber(''); setUserLimit('');
                }else{
                    toastMessage('error', `User added Failed`);
                }
                setButtonLoading(false);
            }).catch(err => {
                setButtonLoading(false);
                (err.response.status === 400) && err.response && validationError(err.response);
                (err.response.status === 401) && clearSession(dispatch, history);
            });
        }else{
            setButtonLoading(false);
            toastMessage('error', `Enter the correct user details`);
        }
    };

    return(
        <>
            <div className="row">
                <div className="col-lg-12 col-xxl-12">
                    {loading ? <div className='min-vh-100 d-flex align-items-center justify-content-center'><Loader type="ThreeDots" color="#2d207d" height={40} width={40} /></div>
                        : <div className="card border-0 card-stretch">
                            <div className="card-header border-0 py-3">
                                <h3 className="card-title align-items-start flex-column">
                                    <span className="card-label font-weight-bolder text-dark">{t("userManagement.addUser.title")}</span>
                                </h3>
                            </div>
                            <div className="card-body pt-0 pb-3">
                                <div className="form-group fv-plugins-icon-container">
                                    <label  className="mb-1">{t("userManagement.addUser.name")}</label>
                                    <input placeholder={t("userManagement.addUser.namePlaceholder")} type="text" className="form-control"
                                        name="Name" value={name} onChange={e => setName(e.target.value)} />
                                </div>
                                <div className="form-group fv-plugins-icon-container">
                                    <label  className="mb-1">{t("userManagement.addUser.email")}</label>
                                    <input placeholder={t("userManagement.addUser.emailPlaceholder")} type="text" className="form-control"
                                        name="Email" value={email} onChange={e => setEmail(e.target.value)} />
                                </div>
                                <div className="form-group fv-plugins-icon-container">
                                    <label  className="mb-1">{t("userManagement.addUser.mobileNumber")}</label>
                                    <input placeholder={t("userManagement.addUser.mobileNumberPlaceholder")} type="text" className="form-control"
                                        name="Mobile Number" value={mobileNumber} onChange={e => setMobileNumber(e.target.value)} />
                                </div>
                                <div className="form-group fv-plugins-icon-container">
                                    <label  className="mb-1">{t("userManagement.addUser.extensionNumber")}</label>
                                    <input placeholder={t("userManagement.addUser.extensionNumberPlaceholder")} type="text" className="form-control"
                                        name="Extension Number" value={extensionNumber} onChange={e => setExtensionNumber(e.target.value)} />
                                </div>
                                <div className="form-group fv-plugins-icon-container">
                                    <label  className="mb-1">{t("userManagement.addUser.emiratesId")}</label>
                                    <input placeholder={t("userManagement.addUser.emiratesIdPlaceholder")} type="text" className="form-control"
                                    name="Extension Number" value={emiratesId} onChange={e => setEmiratesId(e.target.value)} />
                                </div>
                                <div className="form-group fv-plugins-icon-container">
                                    <label  className="mb-1">{t("userManagement.addUser.userLimit")}</label>
                                    <input placeholder={t("userManagement.addUser.userLimitPlaceholder")} type="text" className="form-control"
                                        name="User Limit" value={userLimit} onChange={e => setUserLimit(e.target.value)} />
                                </div>
                                <div className="mb-3">
                                    <p className="mb-1">{t("userManagement.addUser.skills")}<span className="text-danger">*</span></p>
                                    <label className="form-label mb-2">{t("userManagement.addUser.department")}</label>
                                    <div>
                                        {departmentsList.map(({name, id}, index) => 
                                            <div className='d-flex flex-column'>
                                                <div key={id} className='d-flex align-items-center mb-2 c-pointer'>
                                                    <input type='checkbox' className='me-2' value={id} checked={isDeptChecked(id)} onChange={handleSelectedDepartment} />
                                                    <p className="m-0" onClick={() => {handleList('department', id); setDepartmentID(id === departmentID ? '' : id)}}>{name}</p>
                                                </div>
                                                {(departmentID === id) && (masterProcessList.length !== 0) && <div className="mb-3 ms-4">
                                                    <label className="form-label mb-1">{t("userManagement.addUser.masterProcess")}</label>
                                                    <div>
                                                        {masterProcessList.map(({name, id: mpID}) =>
                                                            <div key={mpID} className='d-flex align-items-center mb-1 c-pointer'>
                                                                <input type='checkbox' className='me-2' name={name} id={name} value={mpID}
                                                                    checked={isMPChecked(mpID)} onChange={e => handleSelectedMasterProcess(e, id)} />
                                                                <label className="m-0" htmlFor={name}>{name}</label>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <button disabled={buttonLoading} onClick={handleAddUser} type="button" className="d-flex align-items-center btn btn-primary font-weight-bold mb-2">
                                    {t("userManagement.addUser.title")} {buttonLoading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                                </button>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </>
    );
};

export default AddUser;